import { render, staticRenderFns } from "./InterActor.vue?vue&type=template&id=10fa2ce2&scoped=true&"
import script from "./InterActor.vue?vue&type=script&lang=js&"
export * from "./InterActor.vue?vue&type=script&lang=js&"
import style0 from "./InterActor.vue?vue&type=style&index=0&id=10fa2ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa2ce2",
  null
  
)

export default component.exports